export enum AlertType {
  LABOR_BUDGET_EXCEEDED = "LABOR_BUDGET_EXCEEDED",
  INVOICE_OVERDUE = "INVOICE_OVERDUE",
  INVOICE_OVERDUE_1_WEEK = "INVOICE_OVERDUE_1_WEEK",
  INVOICE_OVERDUE_2_WEEKS = "INVOICE_OVERDUE_2_WEEKS",
  INVOICE_OVERDUE_1_MONTH = "INVOICE_OVERDUE_1_MONTH",
  INVOICE_OVERDUE_2_MONTHS = "INVOICE_OVERDUE_2_MONTHS",
  INVOICE_OVERDUE_3_MONTHS = "INVOICE_OVERDUE_3_MONTHS",
  PAY_APP_OVERDUE = "PAY_APP_OVERDUE",
  PAY_APP_OVERDUE_1_WEEK = "PAY_APP_OVERDUE_1_WEEK",
  PAY_APP_OVERDUE_2_WEEKS = "PAY_APP_OVERDUE_2_WEEKS",
  PAY_APP_OVERDUE_1_MONTH = "PAY_APP_OVERDUE_1_MONTH",
  PAY_APP_OVERDUE_2_MONTHS = "PAY_APP_OVERDUE_2_MONTHS",
  PAY_APP_OVERDUE_3_MONTHS = "PAY_APP_OVERDUE_3_MONTHS",
  LABOR_HOURS_AT_80_PERCENT = "LABOR_HOURS_AT_80_PERCENT",
}

export enum AlertStatus {
  ACTIVE = "ACTIVE",
  DISMISSED = "DISMISSED",
}

export enum AlertCategory {
  BUDGET = "BUDGET",
  COMPLIANCE = "COMPLIANCE",
  OPERATIONAL = "OPERATIONAL",
  SYSTEM = "SYSTEM",
  INVOICE = "INVOICE",
  PAY_APP = "PAY_APP",
  LABOR_HOURS = "LABOR_HOURS",
}

export enum AlertPriority {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
  INFO = "INFO",
}
